export default [
  {
    path: 'index',
    name: 'home',
    meta: { title: '主页', auth: true },
    component: () => import('@home/index.vue'),
  },
];
